// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-27123d6d]{padding-bottom:0;letter-spacing:normal;color:var(--main-theme-color)}.wrap[data-v-27123d6d]{width:500px;margin:0 auto}.item[data-v-27123d6d]{display:flex}.image[data-v-27123d6d]{width:30%}.image img[data-v-27123d6d]{width:100%}.description-box[data-v-27123d6d]{margin:auto 0}.description-box span[data-v-27123d6d]{display:block;font-size:18px;font-weight:700;color:var(--main-theme-color)}", ""]);
// Exports
module.exports = exports;
